<template>
    <div class="twrp-content twrp-content-filter-p" v-if="periodicity != 0 && periodicity < 8">
        <template v-if="periodicity < 7">
            <v-select
                v-if="periodicity != 1"
                v-model="yearModel"
                :items="yearsList"
                hide-details
                outlined
                dense
                append-icon="fas fa-chevron-down"
                class="autocomplete-chip autocomplete-chip-22"
                placeholder="Год"
                :menu-props="{ bottom: true, offsetY: true }"
                style="width:120px;"
                @input="onYearChange"
            >
            </v-select>
        
            <v-select
                v-model="periodModel"
                :items="items"
                hide-details
                outlined
                dense
                append-icon="fas fa-chevron-down"
                class="autocomplete-chip autocomplete-chip-22"
                :placeholder="periodTitle"
                :menu-props="{ bottom: true, offsetY: true }"
                style="width:150px;"
                @input="onPeriodChange"
            ></v-select>
        </template>
        <template v-else>
            <v-menu 
                v-model="dateMenuVisible"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-chip 
                        class="table-label"
                        small
                        label
                        color="teal"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="d-flex align-center">
                            <v-icon>far fa-calendar-alt</v-icon>
                            <template v-if="dateModel == null">
                                {{ $t("Дата") }}
                            </template>
                            <template v-else>
                                {{ dateModel | formattedDate }}
                            </template>
                        </div>
                    </v-chip>
                </template>

                <v-date-picker 
                    v-model="dateModel"
                    @input="onDateChange"
                    color="teal"
                    :first-day-of-week="1"
                >
                </v-date-picker>
            </v-menu>

        </template>

    </div>
</template>
  
<script>
import sys from '@/services/system';
export default {
    name: 'PeriodSelector',

    //$options
    periodisityNames: [
        '',
        'Год',
        'Полугодие',
        'Триместр',
        'Квартал',
        'Месяц',
        'Неделя',
        'День'
    ],
    
    props: {
        periodicity: {
            type: Number,
            required: true,
            validator: value => value > 0 && value < 8
        },
        year: {
            type: Number,
            default: null
        },
        period: {
            type: Number,
            default: null
        },
        date: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            yearModel: this.year,
            periodModel: this.period,
            dateModel: this.date,
            dateMenuVisible: false,
        }
    },
    
    computed: {
        yearsList() {
            return this.getItems(1);
        },
        items() {
            return this.getItems();
        },        
        periodTitle() {
            if (!this.periodicity)
                return '';

            return this.$options.periodisityNames[this.periodicity];
        },
    },

    methods: {
        onDateChange(value) {
            this.$emit('update:date', value);
            if (this.periodicity == 7){
                const dat = this.$moment(value);
                this.onYearChange(dat.year())
                this.onPeriodChange(dat.dayOfYear());     
            }
            this.dateMenuVisible = false; 
        },
        getItems(mode) {
            switch(mode ?? this.periodicity) {
                case 1: {// Year
                    const currentYear = new Date().getFullYear()
                    const years = []
                    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
                        years.push(i)
                    }
                    return years
                }

                case 2: // HalfYear
                    return [
                        { text: '1-е полугодие', value: 1 },
                        { text: '2-е полугодие', value: 2 }
                    ];

                case 3: // Trimester
                    return [
                        { text: '1-й триместр', value: 1 },
                        { text: '2-й триместр', value: 2 },
                        { text: '3-й триместр', value: 3 }
                    ];

                case 4: // Quarter
                    return [
                        { text: '1-й квартал', value: 1 },
                        { text: '2-й квартал', value: 2 },
                        { text: '3-й квартал', value: 3 },
                        { text: '4-й квартал', value: 4 }
                    ];                    

                case 5: // Month
                    return [
                        { text: 'Январь', value: 1 },
                        { text: 'Февраль', value: 2 },
                        { text: 'Март', value: 3 },
                        { text: 'Апрель', value: 4 },
                        { text: 'Май', value: 5 },
                        { text: 'Июнь', value: 6 },
                        { text: 'Июль', value: 7 },
                        { text: 'Август', value: 8 },
                        { text: 'Сентябрь', value: 9 },
                        { text: 'Октябрь', value: 10 },
                        { text: 'Ноябрь', value: 11 },
                        { text: 'Декабрь', value: 12 },
                    ];
                
                case 6: {// Week
                    const weeks = []
                    for (let i = 1; i <= 53; i++) {
                        weeks.push({ text: `Неделя ${i}`, value: i })
                    }
                    return weeks
                }
                    
                case 7: // Day
                default: 
                    return [];
            }
        },
        onYearChange(value) {
            this.$emit('update:year', value);
        },
        onPeriodChange(value) {
            this.$emit('update:period', value);
        },
    },

    filters: {
        formattedDate: function (value) {
            let fr = sys.dateFormat(value, 'DD.MM.YYYY') ?? "";
            return fr;
        }
    },

    watch: {
        year: {
            handler: function(value) {
                this.yearModel = value;
            }
        },
        period: {
            handler: function(value) {
                this.periodModel = value;
            }
        },
        date: {
            handler: function(value) {
                this.dateModel = value;
            }
        }
    }
}
</script>
